import React from 'react';
import { observer } from 'mobx-react';
import {
  Option,
  OptionWrapper,
  OptionCount,
  Arrow,
  ColorArrow,
} from 'libs/forms/styles';
import { Box } from 'components';

import FormInfoIcon from '../FormInfoIcon';

export const MaterialOption = observer(
  ({
    app,
    highlighted,
    highlightedToExpand,
    labelKey,
    onMouseOver,
    onClick,
    scrollRef,
    singleItem = false,
    labelPrefix = '',
    expanded = null,
    isSelectableForEntireCategory,
    singleIndent = false,
  }) => {
    const { tooltip } = app;
    let countDisplay = null;
    if (app.isExpandable && !labelPrefix) {
      countDisplay = <>({app.count})</>;
    }
    let arrow = null;
    if (app.isExpandable && expanded !== null && !singleItem) {
      // expanded may be null, true or false
      if (highlightedToExpand) {
        arrow = (
          <ColorArrow
            name={expanded ? 'caret_up' : 'caret_right'}
            expanded={expanded}
          />
        );
      } else {
        arrow = <Arrow name={expanded ? 'caret_up' : 'caret_right'} />;
      }
    }

    return (
      <OptionWrapper
        ref={scrollRef}
        highlighted={highlighted}
        highlightedToExpand={highlightedToExpand && !singleItem}
        onMouseOver={onMouseOver}
        onClick={onClick}
      >
        <Option
          highlighted={highlighted}
          indentLevel={
            singleIndent
              ? 2
              : isSelectableForEntireCategory
              ? app.getPath.length + 1
              : app.getPath.length
          }
          isExpandable={app.isExpandable}
          expanded={!!expanded}
          isSelectableForEntireCategory={isSelectableForEntireCategory}
          isAutoExpandedCategory={singleItem}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              {labelPrefix}
              {app[labelKey] || 'Untitled'}{' '}
              <OptionCount>{countDisplay}</OptionCount>
            </Box>
            <Box>
              {arrow}
              {tooltip.shortDescription && (
                <FormInfoIcon id={app.id} {...tooltip} />
              )}
            </Box>
          </Box>
        </Option>
      </OptionWrapper>
    );
  },
);
